import { createSelector } from 'reselect';

export const getOrgAgenciesState = state => state.orgAgencies;

export const getOrgAgencies = createSelector([getOrgAgenciesState], agenciesState => agenciesState);

